module.exports = __webpack_public_path__ + "img/airplane-small-black.9e9b7c56.svg";